import type { ElementType, HTMLAttributes, ReactNode } from "react"

import { tv, type VariantProps } from "@/lib/utils/tv"

const surface = tv({
  base: "",
  variants: {
    variant: {
      card: "bg-surface border border-line-subtle",
      selected: "bg-surface border-2 border-line-brand",
      // The raised white panel of the PDP and the mega menu: an inset hairline, so the ring takes no layout.
      panel: "bg-surface ring-line-faint shadow-panel ring-1 ring-inset",
      warm: "bg-surface border-surface-warm-deep border",
      plain: "bg-surface",
    },
    radius: { none: "", md: "rounded-6x", lg: "rounded-8x", "10x": "rounded-10x", xl: "rounded-12x" },
    padding: { none: "", sm: "p-300", md: "p-400", lg: "p-600" },
  },
  defaultVariants: { variant: "card", radius: "lg", padding: "md" },
})

interface SurfaceProps extends HTMLAttributes<HTMLElement>, VariantProps<typeof surface> {
  as?: ElementType
  children?: ReactNode
}

export const Surface = ({ variant, radius, padding, as, className, children, ...rest }: SurfaceProps) => {
  const Element = as ?? "div"
  return (
    <Element className={surface({ variant, radius, padding, className })} {...rest}>
      {children}
    </Element>
  )
}
